export const formattingDate = (date) => {
  // Check for invalid date
  if (!(date instanceof Date) || isNaN(date)) {
    return ""; // Return empty if the input is invalid
  }

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

export const displayDate = (date) => {
  if (!date) return "";
  try {
    return new Date(date).toLocaleDateString([], {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } catch (err) {
    console.error("Invalid date in formatDate:", date, err);
    return "";
  }
};

export const displayTime = (date) => {
  if (!date) return "";
  try {
    return new Date(date).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (err) {
    console.error("Invalid date in formatTime:", date, err);
    return "";
  }
};



